import { render } from "./editCaseDialog.vue?vue&type=template&id=4258d318&scoped=true"
import script from "./editCaseDialog.vue?vue&type=script&lang=js"
export * from "./editCaseDialog.vue?vue&type=script&lang=js"

import "./editCaseDialog.vue?vue&type=style&index=0&id=4258d318&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4258d318"]])

export default __exports__